module.exports = __webpack_public_path__ + "6d55f527cf47e141ee5e249753b3fe6a.pdf";